import React, { PureComponent } from 'react'
import { AdminNavBar } from 'components'

export default class AdminTemplate extends PureComponent {
    render() {
        const { backRoute, className, children } = this.props
        return (
            <div className="darkmode-background">
                <AdminNavBar backRoute={backRoute} />
                <div className={[className, 'flex col-top-center']}>
                    {children}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/templates/AdminTemplate.js